 <template>
    <div class="select-ctr" v-clickoutside="handleClose" @click="toggleMenu">
      <uInput :title="title" :placeholder="placeholder" :readonly="true" v-model="query" ref="input"></uInput>
      <i class="icon-downArrow"></i>
        <transition name="slide-up">
         <uDrop v-show="visible" ref="dropdown">
        	<ul class="itemlist" ref="options">
                   <slot></slot>
                </ul>
            </uDrop>
        </transition>
    </div>
</template>
<script>
import uDrop from "./dropdown.vue";
import clickoutside from "../../directives/clickoutside";
export default {
  name: "uSelect",
  directives: { clickoutside },
  components: { uDrop },
  props: {
  	title: {
  		type: String,
  	},
    value: {
      type: [String, Number, Array],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择...'
    },
    labelInValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      options: [],
      optionInstances: [],
      selectedSingle: "", // label
      focusIndex: 0,
      query: "",
      inputLength: 20,
      notFound: false,
      model: this.value,
    };
  },
  computed: {
    
    showPlaceholder() {
      let status = false;

      if (typeof this.model === "string") {
        if (this.model === "") {
          status = true;
        }
      } else if (Array.isArray(this.model)) {
        if (!this.model.length) {
          status = true;
        }
      }

      return status;
    },
    inputStyle() {
      let style = {};

      if (this.multiple) {
        if (this.showPlaceholder) {
          style.width = "100%";
        } else {
          style.width = `${this.inputLength}px`;
        }
      }

      return style;
    },
    localePlaceholder() {
       return this.placeholder
    }
  },
  methods: {
    toggleMenu() {
      if (this.disabled) {
        return false;
      }

      this.visible = !this.visible;
    },
    hideMenu() {
      this.visible = false;
      this.focusIndex = 0;
     
    },
    findChild(cb) {
      const find = function(child) {
        const name = child.$options.componentName;

        if (name) {
          cb(child);
        } else if (child.$children.length) {
          child.$children.forEach(innerChild => {
            find(innerChild, cb);
          });
        }
      };

      if (this.optionInstances.length) {
        this.optionInstances.forEach(child => {
          find(child);
        });
      } else {
        this.$children.forEach(child => {
          find(child);
        });
      }
    },
    updateOptions(init, slot = false) {
      let options = [];
      let index = 1;
      this.findChild(child => {
        options.push({
          value: child.value,
          label: child.label === undefined ? child.$el.innerHTML : child.label
        });
        child.index = index++;

        if (init) {
          this.optionInstances.push(child);
        }
      });

      this.options = options;

      if (init) {
        this.updateSingleSelected(true, slot);
      }
    },
    updateSingleSelected(init = false, slot = false) {
      const type = typeof this.model;
      if (type === "string" || type === "number") {
        let findModel = false;

        for (let i = 0; i < this.options.length; i++) {
          if (this.model === this.options[i].value) {
            this.selectedSingle = this.options[i].label;
            this.query = this.options[i].label;
            findModel = true;
            break;
          }
        }

        if (slot && !findModel) {
          this.model = "";
          this.query = "";
        }
      }
      this.toggleSingleSelected(this.model, init);
    },
    // 单个
    toggleSingleSelected(value, init = false) {
      if (!this.multiple) {
        let label = "";

        this.findChild(child => {
          if (child.value === value) {
            child.selected = true;
            label =
              child.label === undefined ? child.$el.innerHTML : child.label;
          } else {
            child.selected = false;
          }
        });
        this.hideMenu();
        if (!init) {
          if (this.labelInValue) {
            this.$emit("on-change", {
              value: value,
              label: label
            });
	      this.dispatch('FormItem', 'on-form-change', hybridValue);
          } else {
            this.$emit("on-change", value);
	     this.dispatch('FormItem', 'on-form-change', value);
          }
        }
      }
    },
    handleClose() {
      this.hideMenu();
    },
    resetInputState() {
      this.inputLength = this.$refs.input.value.length * 12 + 20;
    },
  },
  mounted() {
    this.updateOptions(true);
    this.$on("on-select-selected", value => {
      if (this.model === value) {
        this.hideMenu();
      } else {
        this.model = value;
      }
    });
  },
  watch: {
    value(val) {
      console.log(val);
      this.model = val;
      if (val === "") this.query = "";
    },
    model() {
      this.$emit("input", this.model);
      this.updateSingleSelected();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/uselect/uSelect.vue